module.exports = __webpack_public_path__ + "img/notCuredTIncomeSecond.c2705f2a.svg";